import { useState } from "react";

// Patch 62 Part 2 — a short tooltip card whose depth is governed by the SAME Summary/Expanded setting
// the agent explanation stream already uses (100-item round, category 2, item 1; StreamPanel writes
// localStorage["kadana_stream_detail"]). This is not a third level and not an age-labelled tier — it
// simply surfaces the one existing setting in a new, more prominent place, on hover/focus/tap.
export function getDetailLevel() {
  try { return localStorage.getItem("kadana_stream_detail") || "summary"; } catch { return "summary"; }
}

export default function DepthTip({ summary, expanded, children, testid, side = "top" }) {
  const [open, setOpen] = useState(false);
  const [lvl, setLvl] = useState("summary");
  const show = () => { setLvl(getDetailLevel()); setOpen(true); };
  const hide = () => setOpen(false);
  const text = lvl === "expanded" ? (expanded || summary) : summary;
  return (
    <span style={{ position: "relative", display: "inline-flex", alignItems: "center" }}
      onMouseEnter={show} onMouseLeave={hide} onFocus={show} onBlur={hide}
      onClick={() => (open ? hide() : show())}>
      {children}
      {open && (
        <span role="tooltip" data-testid={testid} className="k-container"
          style={{
            position: "absolute", left: "50%", transform: "translateX(-50%)", zIndex: 90,
            bottom: side === "top" ? "calc(100% + 6px)" : "auto",
            top: side === "bottom" ? "calc(100% + 6px)" : "auto",
            width: 240, padding: "8px 10px", fontSize: 12, lineHeight: 1.5,
            boxShadow: "0 8px 30px rgba(0,0,0,.4)", pointerEvents: "none", textTransform: "none",
            fontWeight: 400, letterSpacing: "normal", whiteSpace: "normal",
          }}>
          <span className="k-muted" style={{ display: "block", fontSize: 10, textTransform: "uppercase", letterSpacing: ".08em", marginBottom: 3 }}>{lvl}</span>
          {text}
        </span>
      )}
    </span>
  );
}
